<template>
  <div class="field-wrapper">
    <label>{{label}}<sup v-if="isRequired">*</sup></label>
    <slot name="input-instructions"></slot>
    <select
        v-if="type === 'select'"
        v-model="inputValue"
        :id="id"
        @change="validateField">
      <option v-for="(zone, index) in timezones" :value="zone" :key="index">{{zone}}</option>
    </select>
    <input
        v-else
        :type="type"
        :id="id"
        v-model="inputValue"
        @change="validateField"
        />
    <div :class="['response', { show: response, error: hasError }]">{{response}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      currentAdvertiserId: [Number, String],
      label: String,
      type: String,
      id: String,
      value: [String, Number],
      timezones: Array,
      isRequired: {
        default: true,
        type: Boolean
      }
    },

    name: 'ProfileInput',

    data() {
      return {
        response: null,
        hasError: false,
        inputValue: null,
      }
    },

    methods: {
      validateField() {
        const field = this.id,
            value = this.inputValue

        this.hasError = false
        this.response = null

        if (!this.inputValue) {
          this.response = 'field required'
          this.hasError = true
        } else if (field.includes('phone')) {
          this.validatePhone(field, value)
        } else if (field.includes('email')) {
          this.validateEmail(field, value)
        } else if (field.includes('postal')) {
          this.validateZip(field, value)
        } else {
          const dataToUpdate = { [field]: value }
          this.setField(dataToUpdate, true)
        }
      },

      validatePhone(field, value) {
        const phone = value.replace(/\D/g, ""),
            phone_regex = /^((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/,
            isValid = phone_regex.test(phone),
            dataToUpdate = { [field]: phone },
            errorMessage = 'invalid phone'

        this.setField(dataToUpdate, isValid, errorMessage)
      },

      validateEmail(field, value) {
        const email_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            isValid = email_regex.test(value),
            dataToUpdate = { [field]: value },
            errorMessage = "invalid email"

        this.setField(dataToUpdate, isValid, errorMessage)
      },

      validateZip(field, value) {
        const isValid = value.length === 5,
            dataToUpdate = { [field]: value },
            errorMessage = 'invalid zip'

        this.setField(dataToUpdate, isValid, errorMessage)
      },

      setField(dataToUpdate, isValid, errorMessage) {
        if (isValid) {
          this.updateField(dataToUpdate)
        } else {
          this.response = errorMessage
          this.hasError = true
        }
      },

      updateField(dataToUpdate) {
        const view = this,
          url = `/brands/${view.currentAdvertiserId}`

        this.$api.patch(url, dataToUpdate)
          .then((response) => {
            const data = response.data
            if (data) {
              this.response = 'changes saved'
            } else {
              this.response = 'error, please refresh or contact support'
            }
          })
          .catch((error) => {
            this.response = `${error}`
          })
      },
    },

    created() {
      this.inputValue = this.value
    },

  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.field-wrapper
  max-width: 300px
  label
    display: block
    margin: .5rem auto .25rem auto
    font-size: .9rem
  sup
    vertical-align: super

  input
    border-radius: 6px
    font-size: 1rem
    padding: .5rem
    width: 300px
    margin: 0

  select
    min-width: 318px

.response
  font-size: .9rem
  margin: 0.25rem 0 0 0
  height: 16px
  color: $success-green
  opacity: 0
  transition: all 0.7s ease
  text-align: center

  &.show
    opacity: 1

  &.error
    color: $negative-hover

</style>
